module.exports = __webpack_public_path__ + "img/fast_forward-24px.8ee4484c.svg";